import styled from '@emotion/styled';

/**
 * Элемент с основным текстом блока.
 */
export const Text = styled.div`
  margin-top: 0.75rem;
`;
